"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FQDN = void 0;
exports.FQDN = "https://ipinfo.io";
